import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from '@src/app/_redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { Row, Col, Label, Container } from 'reactstrap';
import { getProdIdsFromAdminConfig } from '@src/app/accounts/selectors';
import { TextArea, SimplerSelectV2, TextInput } from '@src/app/_global/components/form-elements';
import { required, email, selectRequired } from '@src/app/_global/field-validations';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { actionCreators } from '@src/app/accounts/customer-service/actions';
import {  Dispatch, bindActionCreators } from 'redux';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';
import { LoadingView } from '@src/app/_global/components/Loading';
import { ResponseView } from '@src/app/accounts/customer-service/components/ResponseView';
import { countries, countriesWithStatesOrProvinces } from '@src/app/_global/constants';
export interface CustServProps {
  handleSubmit: any;
  clientConfig: any;
  adminConfig: any;
  submitting: any;
  dispatch: any;
  intl: intlShape;
  productNames: any;
  sendCustservEmailStart: any;
  history: any;
  destroy: any;
  change: any;
  custServEmailAddress: any;
  sendEmailData: any;
  sendCustservEmailCancel: any;
  formCountry: any;
  formState: any;
}
export interface OptionsModel {
  label: string;
  value: string;
}
const validate = values => {

  const errors: any = { address: { state: undefined }, 
                        emailSubjectSelected: undefined, email2: undefined,
                        productSelected: undefined, emailAdditionalInfo: undefined };

  const { email1, email2, emailSubjectSelected} = values;
  if (!emailSubjectSelected || emailSubjectSelected.title === '') {
    errors.emailSubjectSelected = 'Required';
  }
  let isError = email1 !== email2;
  if (isError) {
    errors.email2 = 'Emails do not match';
  } 
  if (!values.productSelected || values.productSelected === '') {
    errors.productSelected = 'Required';
  }
  if (!values.emailAdditionalInfo || values.emailAdditionalInfo === '') {
    errors.emailAdditionalInfo = 'Required';
  }
  if (values.address && values.address.countryCode && 
      values.address.countryCode.value in countriesWithStatesOrProvinces && !values.address.state) {
    errors.address.state = 'Required';
  }
  return errors;
    
};
export class Form extends React.Component<CustServProps> {
  history: any = this.props.history;

  state = {
    selectedProdIdAlias: '',
    custServEmailAddress: '',
    customerEmailAddress: '',
    currentSelection: {title: '', prompt: ''},
    currentPrompt: '',
    emailSubjects: [],
    selectedProduct: {label: '', value: ''}
  };

  constructor(props: any, context: any) {
    super(props, context);
    this.onProductChange = this.onProductChange.bind(this);
    this.onReasonChange = this.onReasonChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
  }
  componentDidMount() {
    this.props.sendCustservEmailCancel();
    let customerServiceAdminData = getAdminConfigTableItem(
      this.props.adminConfig,
      this.props.clientConfig,
      'CustomerService',
      this.props.clientConfig.clientConfig.magCode,
    );
    this.setState({
      selectedProdIdAlias: this.props.clientConfig.clientConfig.magCode,
      emailSubjects: customerServiceAdminData.ListConfiguration,
    });
  }
  handleCancel() {
    this.props.sendCustservEmailCancel();
    this.props.destroy();
    this.props.history.push('/accounts/summary');
  }

  onSaveClick(values: any) {
     // tslint:disable-next-line:no-string-literal
    let selectedProduct = values['productSelected'];
    // tslint:disable-next-line:no-string-literal
    let subject = values['emailSubjectSelected'].title;

      let customerServiceAdminData = getAdminConfigTableItem(
        this.props.adminConfig,
        this.props.clientConfig,
        'CustomerService',
        this.state.selectedProdIdAlias,
      );
      let csEmailAddr = customerServiceAdminData.CustomerServiceEmailAddress;
      let customerEmailAddr = values.email1 ;
      let address = {
        name: values.address.name,
        address1: values.address.address1,
        address2: values.address.address2 ? values.address.address2 : '',
        address3: '',
        city: values.address.city,
        state: values.address.state.value || '',
        postalCode: values.address.postalCode || '',
        countryCode: values.address.countryCode.value,
      };
      let customer = {
        address: address,
        prodIdAlias: values.productSelected.value,
        accountNumber: values.accountNumber, 
      };
      let selectedProductName = (selectedProduct ? selectedProduct.label : this.props.productNames[0].label);
      let selectedProdIdAlias = (selectedProduct ? selectedProduct.value : this.props.productNames[0].value);
      this.props.sendCustservEmailStart({
        'emailContent': values, 
        'custServEmailAddress': csEmailAddr,
        'customerEmailAddress': customerEmailAddr,
        'emailSubject': subject,
        'customer': customer,
        'selectedProdIdAlias': selectedProdIdAlias,
        'selectedProductName': selectedProductName,
        'emailType': 'Send Custserv Email',
        'fromLogin': true,
      });
 
  }
  onProductChange(selectedProduct: any) {
    let customerServiceAdminData = getAdminConfigTableItem(
      this.props.adminConfig,
      this.props.clientConfig,
      'CustomerService',
      selectedProduct.value,
    );
    this.setState({
      selectedProduct: selectedProduct,
      selectedProdIdAlias: selectedProduct.value,
      emailSubjects: customerServiceAdminData.ListConfiguration,
      currentSelection: {title: '', prompt: ''},
    });
    this.props.dispatch(change('contact-customer-service', 'emailSubjectSelected', '' ));
  }
  onReasonChange(selectedReason: any) {
    if (selectedReason.title) {
      let customerServiceAdminData = getAdminConfigTableItem(
        this.props.adminConfig,
        this.props.clientConfig,
        'CustomerService',
        this.state.selectedProdIdAlias
      );
      let listItem = customerServiceAdminData.ListConfiguration.find( (item) => {
        return item.title === selectedReason.title;
      });
      this.setState({
        currentPrompt: listItem.prompt,
        currentSelection: listItem
      });
    } else {
      this.setState({
        currentPrompt: '',
        currentSelection: {title: '', prompt: ''},
      });
    }
  }
  render() {
    const { intl, handleSubmit, productNames, submitting, sendEmailData, formCountry} = this.props;
    const formatMessage = (messId, messDisc, messDefault) => {
      const title = intl.formatMessage({
        id: messId,
        description: messDisc,
        defaultMessage: messDefault,
      });
      return title;
    };
    let stateOptions = [{}];
    if (formCountry && formCountry.value in countriesWithStatesOrProvinces) {
      stateOptions = countriesWithStatesOrProvinces[formCountry.value];
    }
    const countryOnChange = event => {
      this.props.dispatch(change('contact-customer-service', 'address.state', ''));
      return true;
    };
      const summaryText = formatMessage(
      'custserv.email.desc',
      'email your info',
      'Your email will be forwarded to a customer service representative for review and resolution.',
    );
    const additionalinfoLabel = (
      <FormattedMessage
        id="custserv.addtionalinfo"
        description="customer service email additional info"
        defaultMessage="Additional information:"
      />
    );
    const emailAddressLabel = formatMessage(
      'email.newemail',
      'heading new email',
      'Please enter your email',
    );
    const confirmEmailAddressLabel = formatMessage(
      'email.confirmemail',
      'heading confirm email',
      'Please enter your email again to confirm'
    );
    const productionSelectLabel = formatMessage(
      'email.product',
      'product selection',
      'Please select which product you wish to contact:',
    );
    const emailSubjectLabel = formatMessage(
      'email.subject',
      'email subject selection',
      'Reason for contacting customer service:',
    );
    const nameLabel = formatMessage('app.name', 'acct detail name', 'Name');
    const address1Label = (
      <FormattedMessage
        id="app.address1"
        description="acct detail address1"
        defaultMessage="Address"
      />
    );
    const address2Label = (
      <FormattedMessage
        id="app.address2"
        description="acct detail address2"
        defaultMessage="Additional Address (optional)"
      />
    );
    const accountNumberLabel = (
      <FormattedMessage
        id="app.acntnum"
        description="acct account number"
        defaultMessage="Account Number(s)"
      />
    );
    const cityLabel = formatMessage('app.city', 'acct detail city', 'City');
    const stateLabel = formatMessage(
      'app.state',
      'acct detail state',
      'State/Province',
    );
    const postalLabel = formatMessage(
      'app.postal',
      'acct detail postal',
      'ZIP/Postal Code',
    );
    const countryLabel = formatMessage(
      'app.country',
      'acct detail country',
      'Country',
    );

    return (
      <Container className="mb-3 mt-3" tabIndex={0} fluid={true}>
      { sendEmailData.loading ? (
          <LoadingView loadingText="Loading..."/>
        ) : (
          sendEmailData.sendEmailResult !== null ? (
          <ResponseView
            onExit={this.handleCancel}
          />
        ) : (
        <form onSubmit={handleSubmit(fields => this.onSaveClick(fields))}>
        <div className="flex-column-wrapper">
          <div className="edit-address-ct">            
            <Row>
            <Col xs={12} sm={12} md={12}>
              <div className="h3 view-heading" id="view-heading">
                <FormattedMessage
                  id="acnt.preferences"
                  description="select preferences"
                  defaultMessage="Contact Customer Service"
                />
              </div>
              <div className="small-text mb-2">
                </div>
               
                <Col xs={12} sm={12} md={6}>
                  <Field
                    id={emailAddressLabel}
                    name="email1"
                    label={emailAddressLabel}
                    validate={[required, email]}
                    component={TextInput}
                    type="text"
                  />
                  <Field
                    id={confirmEmailAddressLabel}
                    name="email2"
                    label={confirmEmailAddressLabel}
                    validate={[required, email]}
                    component={TextInput}
                    type="text"
                  />
                <Field
                  name="address.name"
                  id={'addressName'}
                  label={nameLabel}
                  validate={[required]}
                  component={TextInput}
                  type="text"
                />
                <Field
                  name="address.address1"
                  id={'address1'}
                  label={address1Label}
                  validate={[required]}
                  component={TextInput}
                  type="text"
                />
                <Field
                  name="address.address2"
                  id={'address2'}
                  label={address2Label}
                  component={TextInput}
                  type="text"
                />
                <Field
                  name="address.countryCode"
                  id={'addressCountry'}
                  label={countryLabel}
                  validate={[selectRequired]}
                  component={SimplerSelectV2}
                  options={countries}
                  onChange={countryOnChange}
                  ariaLabel={countryLabel}
                  placeholder={countryLabel}
                  searchable="true"
                  defaultOption={this.props.formCountry || ''}
                />
                <Field
                  name="address.city"
                  id={'addressCity'}
                  label={cityLabel}
                  validate={[required]}
                  component={TextInput}
                  type="text"
                />
                <Field
                  name="address.state"
                  id={'addressState'}
                  label={stateLabel}
                  component={SimplerSelectV2}
                  options={stateOptions}
                  ariaLabel={stateLabel}
                  placeholder={stateLabel}
                  searchable="true"
                  defaultOption={this.props.formState || ''}
                />
                <Field
                  name="address.postalCode"
                  id={'addressPostal'}
                  label={postalLabel}
                  component={TextInput}
                  type="text"
                />
                <Field
                  name="accountNumber"
                  id={'accountNumber'}
                  label={accountNumberLabel}
                  component={TextInput}
                  type="text"
                />
                </Col>
            </Col>
            </Row>
            <div className="small-text mb-2">{summaryText}</div>

            <div className="card">
              <Row className="card-body">
                <Col xs={12} sm={12} md={6} >
                {/* <Label for="productSelected" className="mb-0">{productionSelectLabel} </Label> */}
                  <Field
                    name="productSelected"
                    id="productSelected"
                    component={SimplerSelectV2}
                    options={productNames}
                    onChange={this.onProductChange}
                    ariaLabel={productionSelectLabel}
                    validate={[selectRequired]}
                    placeholder={productionSelectLabel}
                    searchable="true"
                    defaultOption={this.state.selectedProduct}
                  />
                </Col>
              </Row>

              <Row className="card-body">
                <Col xs={12} sm={12} md={6}>
                {/* <Label for="emailSubjectSelected" className="mb-0">{emailSubjectLabel}</Label> */}
                  <Field
                    name="emailSubjectSelected"
                    id="emailSubjectSelected"
                    component={SimplerSelectV2}
                    options={this.state.emailSubjects}
                    valueKey={'title'}
                    labelKey={'title'}
                    onChange={this.onReasonChange}
                    ariaLabel={emailSubjectLabel} 
                    placeholder={emailSubjectLabel}
                    searchable="true"
                    defaultOption={this.state.currentSelection}
                  />
                </Col>
              </Row>
              <Row className="card-body">
              <Col xs={12} sm={12} md={12} >
              <Label for="emailAdditionalInfo" className="mb-0">{additionalinfoLabel} </Label>
              <div>{this.state.currentPrompt}</div>
                <Field
                    name="emailAdditionalInfo"
                    id={'emailAdditionalInfo'}
                    component={TextArea}
                    type="text"
                    rows={4}
                    placeholder="Please provide details about your question"
                  />
                </Col>
              </Row>
            </div>
            <Row className="pulldown">
              <Col xs={12} sm={12} md={12}>
                {/* <div className="notification-ct">
                  {this.props.error && <strong>{this.props.error}</strong>}
                </div> */}
                <div className="d-flex flex-row mt-2 ">
                  
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={submitting}
                  >
                    <FormattedMessage
                      id="app.next"
                      description="acct detail next button"
                      defaultMessage="Send"
                    />
                  </button>
                  <button
                    className="btn btn-light ml-2"
                    type="button"
                    onClick={this.handleCancel}
                  >
                    <FormattedMessage
                      id="app.cancel"
                      description="acct detail cancel button"
                      defaultMessage="Cancel"
                    />
                  </button>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </form>
      )
    )}
    </Container>
    );
  }
}
const CustServReduxForm = reduxForm({
  form: 'contact-customer-service',
  validate,
  destroyOnUnmount: true,
  enableReinitialize: false,
  forceUnregisterOnUnmount: true,
})(Form);
const selector = formValueSelector('contact-customer-service');

const mapStateToProps = (state: RootState) => ({
  selectedProdIdAlias: selector(state, 'productSelected'),
  productNames: getProdIdsFromAdminConfig(state),
  adminConfig: state.adminConfig,
  clientConfig: state.clientConfig,
  sendEmailData: state.account.customerServiceEmailData,
  formCountry: selector(state, 'address.countryCode'),
  formState: selector(state, 'address.state'),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      sendCustservEmailStart: actionCreators.sendCustservEmailStart,
      sendCustservEmailCancel: actionCreators.sendCustservEmailCancel
    },
    dispatch,
  );
export default injectIntl(
  connect((state: RootState, { match: { params } }: any) => mapStateToProps , mapDispatchToProps)(CustServReduxForm),
);
